function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconLocationPin = function SvgIconLocationPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M16.665 1.823A9.25 9.25 0 0 0 2.75 9.811v.76c0 1.545.613 3.02 1.466 4.333.854 1.314 1.971 2.498 3.032 3.468 1.83 1.674 3.582 4.043 3.928 4.52.045.063.14.191.294.284a1.03 1.03 0 0 0 1.06 0c.155-.093.249-.221.294-.284.346-.477 2.098-2.846 3.928-4.52 1.06-.97 2.178-2.154 3.032-3.468.853-1.312 1.466-2.788 1.466-4.334v-.76a9.25 9.25 0 0 0-4.585-7.987Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 4,
    stroke: props.color
  }));
};
export default SvgIconLocationPin;